export default {
  getItems(state, getters, rootState) {
    return rootState.rawData.data[rootState.rawData.year];
  },
};
